import { cx } from '@linaria/core';
import { Button } from '@ui/kit';
import { RetryButton } from '@utils/component-framework';
import { Chevron } from '@utils/react';
import { navigationButtons, footer } from './integration.bottom-navigation.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function BottomNavigation(props) {
  const previousTask = props.component.data.tasks[props.currentTaskIndex - 1];
  const nextTask = props.component.data.tasks[props.currentTaskIndex + 1];
  const isVerticallyAligned = ["top", "bottom"].includes(props.currentTask.alignment);
  const hasContextContent = !!props.currentTask.guide;
  const hasFormContent = props.currentTask.inputs.length > 0;
  const isNarrowContent = isVerticallyAligned || !hasContextContent || !hasFormContent;
  const onResetEntry = () => {
    props.onResetEntry();
    props.onNavigate(undefined);
  };
  return /*#__PURE__*/jsxs("footer", {
    className: cx(footer, props.context === "embedded" && isNarrowContent && "narrow"),
    children: [/*#__PURE__*/jsx(RetryButton, {
      context: "button",
      onReset: onResetEntry
    }), props.component.data.tasks.length > 1 && /*#__PURE__*/jsxs("div", {
      className: navigationButtons,
      children: [/*#__PURE__*/jsx(Button, {
        theme: "white",
        disabled: props.currentTaskIndex === 0,
        onClick: () => props.onNavigate(previousTask?.id),
        icon: {
          position: "before",
          content: /*#__PURE__*/jsx(Chevron, {
            size: 8,
            inversed: true
          })
        },
        children: "Forrige"
      }), /*#__PURE__*/jsx(Button, {
        theme: "white",
        disabled: props.currentTaskIndex === props.component.data.tasks.length - 1,
        onClick: () => props.onNavigate(nextTask?.id),
        icon: {
          position: "after",
          content: /*#__PURE__*/jsx(Chevron, {
            size: 8
          })
        },
        children: "N\xE6ste"
      })]
    })]
  });
}

export { BottomNavigation };
//# sourceMappingURL=integration.bottom-navigation.js.map
